import { process } from '@progress/kendo-data-query';
import {
  Dispatch,
  MouseEvent as ReactMouseEvent,
  SetStateAction,
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from 'react';

import { Button, DropDownButton } from '@progress/kendo-react-buttons';
import { PagerTargetEvent } from '@progress/kendo-react-data-tools';
import { ExcelExport } from '@progress/kendo-react-excel-export';
import { Grid, GridCellProps, GridColumn, GridPageChangeEvent, GridToolbar } from '@progress/kendo-react-grid';
import { TabStrip, TabStripSelectEventArguments, TabStripTab } from '@progress/kendo-react-layout';
import { GridPDFExport } from '@progress/kendo-react-pdf';
import { format } from 'date-fns';
import React from 'react';
import { CSVLink } from 'react-csv';
import SessionStorageService from '../../services/SessionStorageService';
import { GetUserNameTecnico, _export, _exportPdf, b64toBlob, exportPDFWithMethod, get, handleGenericError, hasPermission, post, setCandidaturaSelected, setExcelExport, setPdfExport } from '../../services/utils';
import styles from '../../styles/intervencao/Intervencao.module.scss'
import {  AUTH_LOCALSTORAGE, CONSULTAR_CANDIDATURA, CURRENT_TIMEZONE, GET_DOCUMENTO, GET_DOCUMENTO_BY_CANDIDATURA, GET_LIST_RESULTS_INT_CANDIDATURA, INT_CANDIDATURA_POINT_NAME, PERMISSION_INTERVENCAO_PERFIL_COMPLETO_EDICAO, PERMISSION_INTERVENCAO_PERFIL_COMPLETO_LEITURA, PERMISSION_INTERVENCAO_PERFIL_INTERMEDIO_EDICAO, PERMISSION_INTERVENCAO_PERFIL_INTERMEDIO_LEITURA, PERMISSION_INTERVENCAO_PERFIL_TOTAL, PESQUISAR_CANDIDATURA, PESQUISAR_ENTIDADEBYUSER, RECORDS_LIMIT, RELATORIO_MERGE_CANDIDATURA, URL_AJUDA_INTERVENCOES_CANDIDATURA, clearLayers } from '../../utils/constants';
import { ResultadoCandidaturaCommandGridCell } from './ResultadoCandidaturaCommandGridCell';
import { useCandidaturaStore } from '../../stores/candidatura';
import clsx from 'clsx';
import { useCommonStore } from '../../stores/common';
import commonStyles from '../../styles/common/Common.module.scss'
import MaximizeButton from '../common/MaximizeButton';
import useClearMap from '../../hooks/useClearMap';
import VisualizadorColunas from '../Generico/VisualizadorColunas ';
import useVisibleColumns, { Key } from '../../hooks/useVIsibleColumns';
import ReactGA from 'react-ga4';
import { elementoClickMais, itemRenderMais, mostraFloatingMenu_e_Mapa, ocultaFloatingMenu_e_Mapa, telaMobile } from '../common/ItemRenderMais';
import { ResultadoDocumentoCommandGridCell } from '../documentos/ResultadoDocumentoCommandGridCell';
import ImagePreviewV2 from '../viewer/ImagePreviewV2';
import { Dialog } from '@progress/kendo-react-dialogs';
import moment from 'moment'
import "moment-timezone"
import { base64SiarlImage, base64ApaImage, base64FooterImages } from '../../routes/Base64Images';

type Props = {
  onCloseClick?: (
    e: ReactMouseEvent<HTMLButtonElement, MouseEvent>
  ) => void | undefined
  setShowResultadoCandidatura: Dispatch<SetStateAction<boolean>>
  setShowRegistarCandidatura: Dispatch<SetStateAction<boolean>>,
  setColumns: any,
  columns: any,
  columnsDocuments: any,
  setColumnsDocuments: any
}

const options = [
  {
    key: 'ExportarFichasResultados',
    text: 'Exportar fichas resultados',
    icon: <span className={`icon-siarl icon-exportar ${styles.btnImprimir}`}></span>,
  }
]
type PageState = {
  skip: number
  take: number
}
const initialDataState: PageState = { skip: 0, take: 20 }
const keyPainelPrincipal:Key = 'candidaturaColunasVisiveis';
const keyPainelDocumentos:Key = 'candidaturaDocumentosColunasVisiveis';
export default function ResultadoCandidaturaForm({
  onCloseClick,
  setShowResultadoCandidatura,
  setShowRegistarCandidatura,
  setColumns,
  columns,
  columnsDocuments,
  setColumnsDocuments
}: Props) {
  const [isMobile, setIsMobile] = useState(false);
  const [candidaturas, setCandidaturas] = useState<any[]>([]);
    const [documentosCandidatura, setDocumentosCandidatura] = useState([])
  const [urlDoDocumento, setUrlDoDocumento] = useState("");
  const [idDoDocumento, setIdDoDocumento] = useState("");
  const [openForm, setOpenForm] = useState<boolean>(false)

  const documentosToPreview = documentosCandidatura

  const [selected, setSelected] = useState<number>(0)
  const [page, setPage] = useState<PageState>(initialDataState)

  const isCurrentViewMaximized = useCommonStore(state => state.isCurrentViewMaximized)

  const selectCandidaturaResult = useCandidaturaStore(
    (state) => state.selectCandidaturaResult
  )
  const selectCandidaturaResultId = useCandidaturaStore(
    (state) => state.selectCandidaturaResultId
  )
  const [pageSizeValue, setPageSizeValue] = useState<
    number | string | undefined
  >()

  const getCandidatura = async (data: any) =>
  await get<any, any>(`${PESQUISAR_CANDIDATURA}/` + data)
  const getDocumentosByCandidaturaIDs = async (data: any) =>
  await post<any, any>(`${GET_DOCUMENTO_BY_CANDIDATURA}` , data)
  const getDocumento = async (data: any) =>
    await get<any, any>(`${GET_DOCUMENTO}/` + data)

  const getCandidaturasPorIds = async (data: any) =>
    await post<any, any>(`${GET_LIST_RESULTS_INT_CANDIDATURA}`, data)

  const relatorioCandidaturaMerge = async (data: any) =>
    await post<any, any>(`${RELATORIO_MERGE_CANDIDATURA}`, data)

  const getEntidadeByUser = async (data: any) => await get<any, any>(`${PESQUISAR_ENTIDADEBYUSER}/` + data)

     const handleMessageEvent = useCallback((event: MessageEvent) => {
        if (event.data.type == "resultadoCandidaturaPesquisaChange") {
            SessionStorageService.setItem("resultadoCandidaturaPesquisa", event.data.value);
        }
    }, [])

     useEffect(() => {
        window.addEventListener(
            'message',
            handleMessageEvent,
            false
        )

        return () => {
            window.removeEventListener(
                'message',
                handleMessageEvent,
                false
            )
        }
    }, [handleMessageEvent])

  const consultarCandidatura = async (data: any) => await post<any, any>(`${CONSULTAR_CANDIDATURA}`, data)

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "/ResultadoIntCandidatura" });
  }, []);

  const initialized = useRef(false)
    useEffect(() => {
        if (!initialized.current) {
          initialized.current = true;      if (SessionStorageService.getItem("lastSearchCandidatura") && !SessionStorageService.getItem("firstCallCandidatura") ) {
        postMessage({ type: "showLoader" }, "*");
        const objToSearch = SessionStorageService.getItem("lastSearchCandidatura") ?? '';
        consultarCandidatura(objToSearch).then((data) => {
          SessionStorageService.setItem("resultadoCandidaturaPesquisa", data);
          setResultsCandidatura();
          postMessage({ type: "hideLoader" }, "*");
        })
      } 
      else {
        setResultsCandidatura();
    }
  }
    }, [])

    const setResultsCandidatura = () => {
        const results =SessionStorageService.getItem('resultadoCandidaturaPesquisa') 
        const processData = results.map((candidatura: any) => {
        const acoes = candidatura.lstCandidaturaAcao || [];

        const despesa_elegivel = acoes.reduce(
          (sum: number, acao: any) => sum + (acao.despesa_elegivel || 0),
          0
        );

        const despesa_nao_elegivel = acoes.reduce(
          (sum: number, acao: any) => sum + (acao.despesa_nao_elegivel || 0),
          0
        );

        return {
          ...candidatura,
          despesa_elegivel,
          despesa_nao_elegivel,
          valor_total: despesa_elegivel + despesa_nao_elegivel,
        };
      });
        setCandidaturas(processData);

        const iframe: any = document.getElementById('iframeGeoPortal')
        const ids: any[] = []
        results.forEach((element: any) => {
          ids.push(element.id)
          })

          iframe.contentWindow?.postMessage(
            { type: 'SiarlDefineExtraLayerTooltipColumns', value:
              { layer: INT_CANDIDATURA_POINT_NAME,  columns: columns.columns.filter((x: { show: any; }) => x.show).map((option: { field: any; title: any; }) => ({
           field: option.field,
           title: option.title
         })) } },
            '*'
          )

          iframe.contentWindow?.postMessage(
            { type: 'SiarlCandidaturasSearch', value:{ ids : ids, result:results } },
            '*'
          )
         
      getVisibleColumns(keyPainelPrincipal, setColumns)

        postMessage({ type: 'hideLoader' }, '*');

    }

    useEffect(() => {
      const iframe: any = document.getElementById('iframeGeoPortal')
      const ids: number[] = []
      candidaturas.forEach((element: any) => {
        ids.push(element.id)
      })
      iframe.contentWindow?.postMessage(
        { type: 'SiarlCandidaturasSearch', value: ids },
        '*'
      )
    })

  const [clearMap] = useClearMap();
  const clearSearchResults = () => {
    const iframe: any = document.getElementById('iframeGeoPortal')
    SessionStorageService.removeItem('resultadoCandidaturaPesquisa')
    postMessage({ type: "form", value: "pesquisarCandidatura" }, "*");
    setCandidaturas([]);
    removeColumnsKeys(keyPainelDocumentos)
    removeColumnsKeys(keyPainelPrincipal)
    SessionStorageService.removeItem("lastSearchCandidatura");
    postMessage({type: "clearSearchResultsCandidatura"}, "*")
    clearMap(clearLayers["CLEAR_LAYERS_CANDIDATURA"])
    
  }

  const handleSelect = (e: TabStripSelectEventArguments) => {
    setSelected(e.selected)
    postMessage({type: "subSelectedIntervencaoChange", value: e.selected}, "*");
  }
  const handlePageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent
    const take = event.page.take

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value)
    }

    setPage({
      ...event.page,
      take,
    })
  }

  useEffect(() => {

    try {

      const results = 
        SessionStorageService.getItem('resultadoCandidaturaPesquisa') 
        const processData = results.map((candidatura: any) => {
        const acoes = candidatura.lstCandidaturaAcao || [];

        const despesa_elegivel = acoes.reduce(
          (sum: number, acao: any) => sum + (acao.despesa_elegivel || 0),
          0
        );

        const despesa_nao_elegivel = acoes.reduce(
          (sum: number, acao: any) => sum + (acao.despesa_nao_elegivel || 0),
          0
        );

        return {
          ...candidatura,
          despesa_elegivel,
          despesa_nao_elegivel,
          valor_total: despesa_elegivel + despesa_nao_elegivel,
        };
      });

      setCandidaturas(processData);
      try {
        const idsCandidatura = results.map((o: any) => o.id)
        getDocumentosByCandidaturaIDs(idsCandidatura).then(response => {
          setDocumentosCandidatura(
            response.map((resultDocs: any) => ({
           ...resultDocs,
          data_registo: moment.utc(resultDocs.data_registo).tz(CURRENT_TIMEZONE).format("DD/MM/YYYY HH:mm"),
          data_publicacao: moment.utc(resultDocs.data_publicacao).tz(CURRENT_TIMEZONE).format("DD/MM/YYYY"),
          })))
        })
        
      } catch (error) {
        console.error('Erro ao buscar os dados:', error)
      }

    } catch (e) {
      setCandidaturas([]);
    }

  }, [])

  const handleInfoClickById = (candidaturaLocal: Record<string, any>) => async () => {
    const iframe: any = document.getElementById('iframeGeoPortal')
    const id = candidaturaLocal.int_candidatura_id ?? candidaturaLocal.id;
    const candidatura = await getCandidatura(id);
    if (!candidatura) {
      postMessage({type: "infoMsg", value: {message: "Registo desativado."}}, "*");
      return;
    }

    const tecnico = await GetUserNameTecnico(candidatura.utilizador_id);

    const objToShow = {
      ...candidatura,
      id: candidatura?.id,
      designacao: candidatura?.designacao ?? undefined,
      cod_candid: candidatura?.cod_candid ?? undefined,
      valor_candid: candidatura?.valor_candid ?? undefined,
      valor_comp: candidatura?.valor_comp ?? undefined,
      valor_total: candidatura?.valor_total ?? undefined,
      data_registo: candidatura?.data_registo? new Date(candidatura?.data_registo):null,
      data_hora_registo: candidatura?.data_hora_registo? new Date(candidatura?.data_hora_registo):null,
      data_submissao: candidatura?.data_submissao? new Date(candidatura?.data_submissao):null,
      id_tipo_in: candidatura?.tipo_incidencia ?? undefined,
      instr_financiamento_id: candidatura?.intInstrumentoFinanciamento ?? undefined,
      estado_candidatura_id: candidatura?.intCandidaturaEstado ?? undefined,
      filedoc_cod: candidatura?.filedoc_cod ?? undefined,
      utilizador_id : tecnico
    }
    sessionStorage.setItem('novaCandidatura', 'false')
    selectCandidaturaResult(objToShow)
    setCandidaturaSelected(objToShow);
    setShowResultadoCandidatura(false)
    setShowRegistarCandidatura(true)
    postMessage({type: "form", value: "registarCandidatura"}, "*");
    const idToSend = [candidatura?.id];
    iframe.contentWindow?.postMessage({ type: "SiarlCandidaturaCenter", value: idToSend }, '*')
  }

  
  const candidaturaCustomCell = (props: GridCellProps) => (
    <ResultadoCandidaturaCommandGridCell
      {...props}
      onInfoClick={handleInfoClickById}
      {...conditionalProps}

    />
  )

  const DocumentCommandCell = (props: GridCellProps) => (
    <ResultadoDocumentoCommandGridCell
    onLocationMouseEnter={function (documentos: Record<string, unknown>): void {
      return;
    } } onLocationMouseLeave={function (documentos: Record<string, unknown>): void {
      return;
    } } {...props}
    onInfoClick={handleInfoClickById}
    onDocumentPreviewClick={handleDocumentPreviewClickById}    />
  )

  const handleDocumentPreviewClickById = (documentosLocal: Record<string, any>) => async () => {

    try {

      postMessage({ type: "showLoader" }, "*");
      const documentos = await getDocumento(documentosLocal.id);

      setIdDoDocumento(documentosLocal.id);
      setUrlDoDocumento(documentos.url);
      setOpenForm(true);

    } catch (error) {

      handleGenericError(error, "Não foi possivel abrir o documento!")
      setOpenForm(false);

    } finally {

      postMessage({ type: "hideLoader" }, "*");

    }
  }

  const nextPhoto = async (e: any) => {

    try{

      postMessage({ type: "showLoader" }, "*");
      const nextIds = documentosToPreview
        .filter((doc: any) => doc.id < idDoDocumento && doc.url !== '')
        .map((doc: any) => doc.id);
  
      if (nextIds.length > 0) {
        const nextId = Math.max(...nextIds);
        console.log(`O próximo ID é ${nextId}`);
  
        const documento = await getDocumento(nextId);
  
        setIdDoDocumento(nextId.toString());
        setUrlDoDocumento(documento.url);

        const iframe: any = document.getElementById('iframeGeoPortal')
        
        iframe.contentWindow?.postMessage(
          {
            type: 'SiarlIntMobilizacaoSearchHighlightClick',
            value: [e.int_mobilizacao_id],
          },
          '*'
        )
  
      } else {
        console.log("Não há um próximo ID na lista.");
      }

    }catch(error){

      postMessage({ type: "errorMsg", value: "Não foi possivel abrir o documento!" }, "*");

    }finally{

      postMessage({ type: "hideLoader" }, "*");

      e.preventDefault();
    }
   
  }

  const onItemClickExportarFichas = async () => {
    try {
  
    
      const relatorios = [];
  
      const results = 
        SessionStorageService.getItem('resultadoCandidaturaPesquisa') 
    
   


      const idsCandidatura = results.map((o: any) => o.id);

      if(idsCandidatura.length  > RECORDS_LIMIT){
        postMessage({ type: 'errorMsg', value: { message: "Não é possivel exportar mais de 100 fíchas" } }, '*')
        return false
        }
    
  
  
      const candidaturas = await getCandidaturasPorIds(idsCandidatura);
      
        postMessage({ type: 'showLoader' }, '*');
      
        for (const candidaturaId of idsCandidatura) {
  
        const candidatura = candidaturas.find((candidatura: any) => candidatura.id === candidaturaId);
  
        const ResultEntidade = await getEntidadeByUser(candidatura?.utilizador?.id)
     
        const relatorio = {
          id: candidatura?.id,
          dados: {
          
            'REGISTO' : '',
            'Nº processo APA:': candidatura?.filedoc_cod ?? '',
            'Estado:': candidatura?.intCandidaturaEstado?.descricao ?? '',
            'Data/Hora Registo:': candidatura?.data_hora_registo ? new Date(candidatura.data_hora_registo).toLocaleDateString(): '',
            'Técnico:': candidatura?.utilizador_registo ?? '',
            'Entidade:': candidatura?.nome ?? '',
            
            'IDENTIFICACAO' : '',
            'Numero da candidatura:': candidatura?.cod_candid ?? '',
            'Investimento previsto:': candidatura?.inv_previsto_total ?? '',
            'Data registo:': candidatura?.data_registo ? new Date(candidatura.data_registo).toLocaleDateString() : '',
            'Investimento comunitario:': candidatura?.inv_comp_total ?? '',
            'Data de submissão:': candidatura?.data_submissao ? new Date(candidatura.data_submissao).toLocaleDateString() : '',
            'Investimento nacional:': candidatura?.inv_nacional_total ?? '',
            'Designação:': candidatura?.designacao ?? '',
  
  
            'Fonte de finaciamento:': candidatura?.tipo_incidencia?.descricao ?? '',
            'Instrumento de finaciamento:': candidatura?.intInstrumentoFinanciamento?.designacao ?? '',
            'Observacoes': candidatura?.obs ?? '',
  
          },

       

          
        };

        
        relatorios.push(relatorio);
    }
  
      const mergedPdfBase64 = await relatorioCandidaturaMerge(relatorios);
      if (mergedPdfBase64) {
        const blob = b64toBlob(mergedPdfBase64, 'application/pdf');
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl, '_blank');
      }
    } catch (error) {
      console.log(error);
      postMessage({ type: 'errorMsg', value: { left: '50%', message: "Verifique os campos obrigatórios." } }, '*');
    } finally {
      postMessage({ type: 'hideLoader' }, '*');
    }
  };

  const previousPhoto = async (e: any) => {

    try{

      postMessage({ type: "showLoader" }, "*");
      const previousIds = documentosToPreview
        .filter((doc: any) => doc.id > idDoDocumento && doc.url !== '')
        .map((doc: any) => doc.id);
  
      if (previousIds.length > 0) {
        const previousId = Math.min(...previousIds);
        console.log(`O anterior ID é ${previousId}`);
  
        const documento = await getDocumento(previousId);
  
        setIdDoDocumento(previousId.toString());
        setUrlDoDocumento(documento.url);

        const iframe: any = document.getElementById('iframeGeoPortal')
        iframe.contentWindow?.postMessage(
          {
            type: 'SiarlIntMobilizacaoSearchHighlightClick',
            value: [e.int_mobilizacao_id],
          },
          '*'
        )
      } else {
        console.log("Não há um anterior ID na lista.");
      }

    }catch(error){

      handleGenericError(error, "Não foi possivel abrir o documento!")

    }finally{

      postMessage({ type: "hideLoader" }, "*");

      e.preventDefault();
    }
       
  }

  const [dataState, setDataState] = React.useState({
    skip: 0,
    take: 20,
    sort: [],
    group: [],
  });

  const [dataStateDocumentos, setDataStateDocumentos] = React.useState({
    skip: 0,
    take: 20,
    sort: [],
    group: [],
  });

  const dataStateChange = (event: any) => {
    setDataResult(process(candidaturas, event.dataState));
    setDataState(event.dataState);

    const skipPag: PageState = { skip: event.dataState.skip, take: event.dataState.take}
setPage({
  ...skipPag
})
    
  };

  const [dataResult, setDataResult] = React.useState(
    process(candidaturas, dataState)
  );

  const dataStateChangeDocumentos = (event: any) => {
    setDataResultDocumentos(process(documentosCandidatura, event.dataState));
    setDataStateDocumentos(event.dataState);
  };

  const [dataResultDocumentos, setDataResultDocumentos] = React.useState(
    process(documentosCandidatura, dataStateDocumentos)
  );


  const itemRender = (props: { item: any; itemIndex: number }) => {
    const isTitleItem = props.item.key === 'titulo';
    if (isTitleItem) {
      // Item de título personalizado
      return (
        <div className={styles.DropDownButtonTitulo}>
          <span>{props.item.text}</span>
        </div>
      );
    } else {
      // Demais itens
      return (
        <div className={styles.DropDownButtonItem}>
          <span>{props.item.text}</span>
        </div>
      );
    }
  };

  const optionsExportar = [
    {
      key: 'ExportarListaResultadosExcel',
      text: 'Excel',
    },
    {
      key: 'ExportarTodasFichas',
      text: 'Fichas',
    },
  ]
  
  const exportExcel = () => {
    _export.save();
  };

  const openPdfNewTab = () => {
    return new Promise<void>((resolve, reject) => {
        
        postMessage({ type: "showLoader" }, "*");

        setTimeout(() => {
           const columnsToShow = columns.columns.filter((x: any) => x.show);
            const dataToExport = candidaturas.map((item: any) => {
                const filteredItem: any = {};
                columnsToShow.forEach((column: any) => {
                    filteredItem[column.field] = item[column.field];
                });
                return filteredItem;
            });
            
            exportPDFWithMethod(columnsToShow, dataToExport, 8)
                .then((pdfData: any) => {
                    postMessage({ type: "hideLoader" }, "*");

                        const base64Data = pdfData.split(";base64,")[1];
                        console.log(base64Data);
                        const blob = b64toBlob(base64Data, 'application/pdf');
                        const blobUrl = URL.createObjectURL(blob);

                      
                        window.open(blobUrl, '_blank');
                        resolve();
                  
                })
                .catch(error => {
                    console.error('Error exporting PDF:', error);
                    reject(error);
                });
        }, 1000);
    });
};

  const onItemClickExportar = async (event: any) => {
    
    if(event.item.key == "ExportarTodasFichas"){
      onItemClickExportarFichas();
    }
    if(event.item.key == "ExportarListaResultadosExcel"){
        exportExcel();
    }
  }

  const exportPDF = () => {
    _exportPdf.save();
  };

  const onItemClickImprimir = async (event: any) => {
    openPdfNewTab();
  }


  const {getVisibleColumns, removeColumnsKeys} = useVisibleColumns();
 
  useEffect(() => {
    SessionStorageService.setItem(keyPainelPrincipal, JSON.stringify(columns));
    const iframe: any = document.getElementById('iframeGeoPortal')
    iframe.contentWindow?.postMessage(
      { type: 'SiarlDefineExtraLayerTooltipColumns', value:{  layer: INT_CANDIDATURA_POINT_NAME,  columns: columns.columns.filter((x: { show: any; }) => x.show).map((option: { field: any; title: any; }) => ({
     field: option.field,
     title: option.title
   })) } },
      '*'
    )
  }, [columns]);

   useLayoutEffect(() => {

    const handleResize = () => {

      if (window.innerWidth <= telaMobile) {
        
        setIsMobile(true);
        ocultaFloatingMenu_e_Mapa();

      }else{

        setIsMobile(false);
        mostraFloatingMenu_e_Mapa();

      }

    };
  
    window.addEventListener('resize', handleResize);
  
    handleResize();
  
    return () => {
      window.removeEventListener('resize', handleResize);
    };

  }, []);  


  const onItemClickMais = (event: any) => {

    elementoClickMais(event);

    onItemClickExportar(event);

    onItemClickImprimir(event);
    
  };

  const optionsMais = [
    {
      key: 'titulo',
      text: 'Imprimir',
    },
    {
      key: 'imprimirFicha',
      text: 'Resultados',
      className: 'icon-siarl icon-imprimir btnIconRegistar'
    },
    {
      key: 'titulo',
      text: 'Exportar',
    },
    ...optionsExportar.map(option => ({
      ...option,
      className: 'icon-siarl icon-exportar btnIconRegistar',
    })),
  ]

  const handleNewRegistoClick = () => {
      setCandidaturaSelected(undefined);
      setCandidaturaSelected(undefined);
      selectCandidaturaResult(undefined);
      setShowResultadoCandidatura(false)
      const loggedUser = JSON.parse(
        localStorage.getItem(AUTH_LOCALSTORAGE) ?? '{}'
      )
      setCandidaturaSelected({ utilizador_id: loggedUser?.user?.name })
      sessionStorage.setItem('novaCandidatura', 'true')
      if (setShowRegistarCandidatura) setShowRegistarCandidatura(true)
  }

  const openAjuda = () => {
    window.open(URL_AJUDA_INTERVENCOES_CANDIDATURA, "_blank")
  }

  const canSeeCandidatura = 
hasPermission(PERMISSION_INTERVENCAO_PERFIL_COMPLETO_LEITURA) ||
hasPermission(PERMISSION_INTERVENCAO_PERFIL_INTERMEDIO_EDICAO) ||
hasPermission(PERMISSION_INTERVENCAO_PERFIL_INTERMEDIO_LEITURA) ||
hasPermission(PERMISSION_INTERVENCAO_PERFIL_TOTAL);


const conditionalProps =  canSeeCandidatura
? { 
    onInfoClick: handleInfoClickById
} 
: {};

const PageTemplate = (props: any) => (
  <div className="page-template">
     <div className="header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '10px', padding: '10px' }}>
    
     <div>
     <img style={{ width: '128px', height: 'auto', marginLeft: '2px' }} src={base64SiarlImage} alt="SIARL Logo" />
     </div>
     <div style={{ textAlign: 'right' }}>
       <span style={{ fontSize: '18px', color: '#1ba49c' }}>PESQUISA DE CANDIDATURAS</span>
     </div>
   </div>
   <div className="footer" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '10px' }}>
      
     <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
       <img style={{ width: '105px', marginBottom: '-25px' }} src={base64ApaImage} alt="APA Logo" />
       <img style={{ width: '280px', height: 'auto', marginBottom: '-25px' }} src={base64FooterImages} alt="Footer Image" />
     </div>
    
     <div style={{ flex: 1, textAlign: 'right', marginBottom: '-25px' }}>
      Data : {format(new Date(), "dd/MM/yyyy")} | Página {props.pageNum} de {props.totalPages}
     </div>
   </div>
 </div>
);


  return (
    <div className={clsx(styles.base, isCurrentViewMaximized && commonStyles.maximizedBaseForm)}>
      {/* <div className={styles.header}>
        <div>
          <div className={styles.nomeDoModulo}>
            Candidaturas
          </div>
          <div className={styles.tituloDaPagina}>
            Resultados de pesquisa
          </div>
        </div>

        <div>

          {hasPermission(PERMISSION_INSERIR_INTERVENCAO) && (  
            hasPermission(PERMISSION_INTERVENCAO_PERFIL_COMPLETO_EDICAO) ||
            hasPermission(PERMISSION_INTERVENCAO_PERFIL_INTERMEDIO_EDICAO)
            )? 
            <Button
              onClick={handleNewRegistoClick}
              className={styles.btnNovoRegisto}
              style={{ display: isMobile ? 'none' : '' }}
              id='novoRegisto'
              title='Nova candidatura'
            >
              <span className="icon-siarl icon-registar btnIconRegistar" /> &nbsp;{' '}
              Nova candidatura
            </Button>
          :  ''}

          {canSeeCandidatura?<>
          <CSVLink
            title="Imprimir resultados"
            id="print-results-candidatura"
            separator={";"}
            data={
              candidaturas.map((candidatura: any) => ({
                ...candidatura,
              }))}
            filename={`siarl-candidatura-${format(new Date(), 'ddMMyyyHHmm')}`}
            hidden
          >
          </CSVLink>
          </>:<></>}

          {!isMobile &&
          <VisualizadorColunas 
              columns={selected===0?colums:columsDocuments} 
              setColumns={selected===0?setColums:setColumsDocuments}
              styles={styles.btnEditar2} 
           />
          }

        <button className={styles.btnEditar2} onClick={onItemClickImprimir} style={{ display: isMobile ? 'none' : '' }} id='imprimirFicha' title='Imprimir'>
          <span className="icon-siarl icon-imprimir"></span>
        </button>

          {!isMobile &&
          <DropDownButton 
            items={optionsExportar}
            className={styles.btnImprimir}
            style={{marginTop: '-4px'}}
            iconClass='icon-siarl icon-exportar'
            onItemClick={onItemClickExportar}
            fillMode={"flat"}
            itemRender={itemRender}
            title='Exportar'
          >
          </DropDownButton>
        }
 
          {isMobile &&
            <DropDownButton
              items={optionsMais}
              className={styles.btnMais}
              iconClass="icon-siarl icon-mais"
              onItemClick={onItemClickMais}
              fillMode={'flat'}
              itemRender={itemRenderMais}
              title="Mais Opções"
            />
          }

          {isMobile &&
            <DropDownButton
              items={optionsMais}
              className={styles.btnMais}
              iconClass="icon-siarl icon-mais"
              onItemClick={onItemClickMais}
              fillMode={'flat'}
              itemRender={itemRenderMais}
              title="Mais Opções"
            />
          }

          <button onClick={openAjuda} className={styles.btnInfo} title="Obter Ajuda">
              <span className="icon-siarl icon-ajuda"></span>
          </button>
          <button className={styles.btnFechar} onClick={onCloseClick} title="Minimizar">
            <span className="icon-siarl icon-minimizar"></span>
          </button>

          {!isMobile &&
          <MaximizeButton className={styles.btnMaximizar} />
          }
        </div>

      </div> */}

      {canSeeCandidatura?
      <TabStrip selected={selected} onSelect={handleSelect} scrollable={isMobile}>
        <TabStripTab title="Registos">
          <ExcelExport
            fileName='Resultado_Candidaturas'
            data={candidaturas}
            ref={(exporter) => {
              setExcelExport(exporter)
            }}
          >
            <Grid className={styles.formResultadoTabs}
              sortable={true}
              onDataStateChange={dataStateChange}
              data={dataResult.data.length > 0 ? dataResult : candidaturas.slice(page.skip, page.take + page.skip)}
              total={candidaturas.length}
              {...dataState}
              skip={page.skip}
              take={page.take}
              pageable={{
                buttonCount: 5,
                info: true,
                type: 'numeric',
                pageSizes: true,
                previousNext: true,
              }}
              //groupable={true}
            >
              <GridColumn cell={candidaturaCustomCell} width={30} />
              {columns?.columns?.map((column: { show: any; field: string | undefined; width: string | number | undefined; title: string | undefined; }, i: React.Key | null | undefined) => {
            return (
              column.show && (
                <GridColumn key={i}  field={column.field} width={column.width} title={column.title} />
              )
            );
          })}
            </Grid>
          </ExcelExport>

          <GridPDFExport  
           fileName='Resultado_Candidatura'
         
           paperSize="A4"
           margin={{ top: '3cm', right: '1cm', bottom: '2cm', left: '1cm' }}
           landscape={true}
           pageTemplate={PageTemplate} 
           repeatHeaders={true}
           ref={(exporter) => {
             setPdfExport(exporter)
           }}
          >
               {
              <Grid
                sortable={true}
                 data={candidaturas}                
                pageable={{
                  buttonCount: 5,
                  info: true,
                  type: 'numeric',
                  pageSizes: true,
                  previousNext: true,
                }}
                style={{ borderSpacing: '0' }} 
                //groupable={true}
              >
                {columns?.columns?.map((column: any, i: any) => {
            return (
              column.show && (
                <GridColumn key={i}  field={column.field} filter={column.filter} width={column.width} title={column.title} columnMenu={column.columnMenu}
                headerCell={() => <div className="pdf-header">{column.title}</div>}
                cell={(props: any) => (
                  <td style={{ fontSize: '10px', wordBreak: 'break-word', padding: '5px', border: '1px solid #1ba49c' , lineHeight: '1.3' }}>
                    {props.dataItem[column.field]}
                  </td>
                )}
                />
              )
            );
          })}
              </Grid>
            }
          </GridPDFExport>

        </TabStripTab>

        <TabStripTab title="Documentos">

          <ExcelExport
            fileName='Resultado_DocumentosCandidatura'
            data={documentosCandidatura}
            ref={(exporter) => {
              setExcelExport(exporter)
            }}

          >
            <Grid className={styles.formResultadoTabs}
              sortable={true}
              onDataStateChange={dataStateChangeDocumentos}
              data={dataResultDocumentos.data.length > 0 ? dataResultDocumentos : documentosCandidatura.slice(page.skip, page.take + page.skip)}
              {...dataState}
              pageable={{
                buttonCount: 5,
                info: true,
                type: 'numeric',
                pageSizes: true,
                previousNext: true,
              }}
               total={documentosCandidatura.length}
              //groupable={true}
            > 
            <GridColumn cell={DocumentCommandCell} width={56} />
                {columnsDocuments?.columns?.map((column: { show: any; field: string | undefined; width: string | number | undefined; title: string | undefined; }, i: React.Key | null | undefined) => {
            return (
              column.show && (
                <GridColumn key={i}  field={column.field} width={column.width} title={column.title} />
              )
            );
          })}
            </Grid>

          </ExcelExport>

          <GridPDFExport  
            fileName='Resultado_Documentos_Candidatura'
            ref={(element) => {
              setPdfExport(element);
            }}
            margin="1cm"
          >
            <Grid className={styles.formResultadoTabs}
              sortable={true}
              onDataStateChange={dataStateChangeDocumentos}
              data={dataResultDocumentos.data.length > 0 ? dataResultDocumentos : documentosCandidatura}
              {...dataState}
              pageable={{
                buttonCount: 5,
                info: true,
                type: 'numeric',
                pageSizes: true,
                previousNext: true,
              }}
              //groupable={true}
            >
          {columnsDocuments?.columns?.map((column: { show: any; field: string | undefined; width: string | number | undefined; title: string | undefined; }, i: React.Key | null | undefined) => {
            return (
              column.show && (
                <GridColumn key={i}  field={column.field} width={column.width} title={column.title} />
              )
            );
          })}
            </Grid>

          </GridPDFExport>

        </TabStripTab>
      </TabStrip>:<></>}
      
      <div className={clsx(styles.footer, styles.justify_one_child, isCurrentViewMaximized && commonStyles.maximizedFooter)}>
        <Button
          className={styles.btnPesquisar}
          onClick={clearSearchResults}
          title='Nova Pesquisa'
        >
          <span className="icon-siarl icon-pesquisar"></span>
          <span className={styles.rotulo}>
            {' '}&nbsp;{' '}
            Nova pesquisa
          </span>          
        </Button>
      </div>
      {openForm && (
        <Dialog
        className="ModalDocumentos"
          title={`Documento: ${idDoDocumento}`}
          onClose={() => setOpenForm(false)}
          style={{ zIndex: 999 }}
        >
          
            <ImagePreviewV2
              documentUrl={urlDoDocumento}
              next={(e: any) => nextPhoto(e)}
              previous={(e: any) => previousPhoto(e)}
            />

        </Dialog>
      )}
    </div>
    
  );
}